var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1170_90857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2904 5.4137L10.5644 1.73151L11.7918 0.50411C12.1279 0.168037 12.5408 0 13.0306 0C13.5204 0 13.933 0.168037 14.2685 0.50411L15.4959 1.73151C15.832 2.06758 16.0073 2.47321 16.0219 2.94838C16.0365 3.42356 15.8758 3.82889 15.5397 4.16438L14.2904 5.4137ZM13.0192 6.70685L3.72603 16H0V12.274L9.29315 2.98082L13.0192 6.70685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEdit);
export default __webpack_public_path__ + "static/media/PencilEdit.02e0af0deab816132dc47fac840e4bfc.svg";
export { ForwardRef as ReactComponent };